// extracted by mini-css-extract-plugin
export default {"scrol":"scroll_scrol__aElr1"};